import { Box, useColorModeValue } from '@chakra-ui/react'
import React from 'react'

type Props = {
    status: boolean
}

const GabStatus: React.FC<Props> = ({ status }) => {
  const color = useColorModeValue('gray.300', 'white');

  return (
    <Box w={'1.2rem'} h={'1.2rem'} bg={status ? 'red' : color}></Box>
  )
}

export default GabStatus